import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var OptionContentImg = /*#__PURE__*/memo(function (_ref) {
  var iconSrc = _ref.iconSrc;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('option-content__picture'),
    "data-t-id": "components-OptionContentImg"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cn('option-content__img'),
    src: iconSrc
  }));
});